module.exports = __webpack_public_path__ + "img/soil_moisture.2daf8598.svg";